const pattern = /(.+)\s\[(.+)-(.+)]/

export class UnmatchedPatternError extends Error {}

/**
 * Extracts the numerical value from the data provided by the CSV file, which includes the confidence intenvals as well.
 * @param inputString
 * @throws {UnmatchedPatternError}
 */
export function extractValue(inputString: string) {
  if (inputString === '.') return null
  const results = pattern.exec(inputString)
  if (results === null) {
    throw new UnmatchedPatternError(inputString + ' can not be matched.')
  } else {
    return parseFloat(results[1])
  }
}
